import { render, staticRenderFns } from "./SlotGameItem.vue?vue&type=template&id=1e24c1a6&"
import script from "./SlotGameItem.vue?vue&type=script&lang=js&"
export * from "./SlotGameItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports